export default {
  common: {
    login: "Login",
    loginRequired: "Login Required",
    logout: "Logout",
    signup: "Sign Up",
    home: "Home",
    search: "Search",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    welcome: "Welcome",
    loading: "Loading...",
    error: "An error occurred",
    noData: "No data available",
    number: "No.",
    title: "Title",
    date: "Date",
    type: "Type",
    status: "Status",
    canceled: "Canceled",
    approved: "Approved",
    rejected: "Rejected",
    waiting: "Waiting",
    reset: "Reset",
    submit: "Submit",
    success: "Success",
    failed: "Failed",
    amountMustBeGreaterThan0: "Amount must be greater than 0",
  },
  header: {
    announcement: "We are now open!",
    login: "Login",
    register: "Register",
    casino: "Live Casino",
    slotGame: "Slot Games",
    liveSports: "Live Sports",
    cashIn: "Cash In",
    cashOut: "Cash Out",
    needHelp: "Need Help?",
    honorific: "",
    chip: "Chips",
    point: "Points",
    partnerPage: "Partner Page",
  },
  slider: {
    casino: {
      subtitle: "SHOGUN LIVE CASINO",
      title1: "Live Casino",
      title2: "Satisfaction guaranteed for all players",
    },
    slot: {
      subtitle: "SHOGUN SLOT GAME",
      title1: "Live Slots",
      title2: "Satisfaction guaranteed for all players",
    },
    sports: {
      subtitle: "SHOGUN SPORTS",
      title1: "Live Sports",
      title2: "Satisfaction guaranteed for all players",
    },
  },
  homePage: {
    casino: {
      title: "Live Casino",
      subtitle: "SHOGUN CASINO",
    },
    slot: {
      title: "Slots",
      subtitle: "SHOGUN SLOT",
    },
  },
  gameList: {
    showAll: "Show All",
    underMaintenance: "Under Maintenance",
  },
  board: {
    faq: {
      subtitle: "Frequently Asked Questions",
      title: "FAQ",
      viewMore: "View More FAQs",
      items: [
        {
          id: 1,
          title: "What kind of company is 'SHOGUN'?",
          content: "'SHOGUN' is a global gaming platform providing online casino and mobile casino services. We operate 24/7 and offer over 100 different casino games."
        },
        {
          id: 2,
          title: "Is the site safe?",
          content: "Yes, SHOGUN implements the latest security systems to protect our members' personal information and assets. All transactions are encrypted, and we conduct regular audits to ensure a fair gaming environment."
        },
        {
          id: 3,
          title: "Are there many games?",
          content: "Yes, SHOGUN offers over 100 different games. You can enjoy various genres including live casino, slot games, and mini games. Particularly in progressive jackpot games, you can win big prizes."
        },
        {
          id: 4,
          title: "How about deposits and withdrawals?",
          content: "SHOGUN supports various deposit and withdrawal methods. You can use bank transfers, cryptocurrency (USDT), and other convenient methods. Deposits are processed within 5-10 minutes."
        }
      ]
    },
    notice: {
      subtitle: "Announcements",
      title: "Latest News",
      viewMore: "View More Notices",
    },
  },
  footer: {
    ourPartners: "Our Partners",
    copyright: "Copyright 2024 SHOGUN. All rights reserved",
    casino: "Live Casino",
    slotGame: "Slot Games",
    miniGame: "Mini Games",
  },
  auth: {
    login: "Login",
    register: "Register",
    username: "Username",
    password: "Password",
    passwordConfirm: "Confirm Password",
    passwordMismatch: "Passwords do not match",
    rememberPassword: "Remember Password",
    captcha: "Enter CAPTCHA text",
    referrer: "Referral Code",
    phone: "Phone Number",
    nameBank: "Bank Name",
    numberBank: "Account Number",
    userBank: "Account Holder",
    loginFailed: "Login Failed",
    registerFailed: "Registration Failed",
  },
  maintenance: {
    title: "Be Right Back!",
    message: "System is under maintenance. We apologize for the inconvenience.",
  },
  homePopup: {
    selectList: "Select List",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    bankingHistory: "Banking History",
    pointToChip: "Point to Chip",
    notice: "Notice",
    inquiry: "Inquiry",
    myInfo: "My Info",
    betHistory: "Bet History",
    faq: "FAQ",
  },
  betting: {
    name: "Bet Name",
    game: "Game",
    type: "Type",
    amount: "Amount",
    date: "Date",
    status: {
      win: "WIN",
      lose: "LOSE",
      bet: "BET",
    },
  },
  deposit: {
    notice: "Please check your deposit information carefully",
    info: "Deposits will be processed within 5-10 minutes",
    currentBalance: "Current Balance",
    amount: "Deposit Amount",
    usdtAmount: "USDT Deposit Amount",
    requestAccount: "Request Deposit Account",
    requestUsdtAddress1: "Polygon USDT Address",
    requestUsdtAddress2: "Tron USDT Address",
    myWallet: "My Wallet",
    bottomNotice: "Please contact customer service if you need assistance",
    title: "Deposit",
    normalDeposit: "Normal Deposit",
    usdtDeposit: "USDT Deposit",
  },
  withdrawal: {
    notice: "Please check your withdrawal information carefully",
    currentBalance: "Current Balance",
    walletAddress: "Wallet Address",
    amount: "Withdrawal Amount",
    usdtAmount: "USDT Withdrawal Amount",
    myWallet: "My Wallet",
    password: "Withdrawal Password",
    title: "Withdrawal",
    normalWithdrawal: "Normal Withdrawal",
    usdtWithdrawal: "USDT Withdrawal",
  },
  banking: {
    bankAccountRequired: "Bank account information is required",
  },
  bankinghistory: {
    beforeBalance: "Before Balance",
    requestAmount: "Request Amount",
    afterBalance: "After Balance",
  },
  profile: {
    username: "Username",
    balance: "Balance",
    point: "Points",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    passwordChanged: "Password changed successfully",
    passwordMismatch: "Passwords do not match",
    invalidPassword: "Invalid current password",
  },
  notice: {
    unread: "Unread",
    read: "Read",
  },
  inquiry: {
    title: "Inquiry Title",
    select: "Select Inquiry Type",
    writer: "Writer",
    placeholder: "Enter your inquiry (max 100 characters)",
    types: {
      deposit: "Deposit Inquiry",
      withdrawal: "Withdrawal Inquiry",
      account: "Account Request",
      other: "Other Inquiry",
    },
    question: "Question",
    answer: "Answer",
    status: "Status",
    pending: "Pending",
    inProgress: "In Progress",
    completed: "Completed",
    unknown: "Unknown",
    empty: "No inquiries found",
    reply: "Reply",
    send: "Send",
    note: "Waiting for response",
    showMore: "Show more",
    showLess: "Show less",
    newInquiry: "New Inquiry",
    delete: "Delete",
    deleteConfirmation: "Are you sure you want to delete this inquiry?",
  },
  point: {
    currentBalance: "Current Points",
    amount: "Conversion Amount",
    enterAmount: "Enter amount",
    password: "Password",
    enterPassword: "Enter password",
    convert: "Convert",
    invalidAmount: "Invalid amount",
    convertSuccess: "Points converted successfully",
  },
}; 